import { SonarSortDirection } from '@sonar-software/sonar-ts-types';
import { TimelineBaseRequest } from '@types';
import { TimelineDetailsTableColumnKey } from './getTimelineDetails';

import { createPostEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type PostTimelineExportRequest = TimelineBaseRequest & {
	sortBy?: TimelineDetailsTableColumnKey;
	sortDirection?: SonarSortDirection;
};

export type PostTimelineExportResponse = { id: number };

export const postTimelineExportStart = createPostEndpoint<
	PostTimelineExportRequest,
	PostTimelineExportResponse
	>(
		(request) => `/api/v3/core/exports/timeline-details/export/start?${getQueryString(request)}`
	);
